module.exports = __webpack_public_path__ + "static/media/Chat button small light.695f20d1.png";